const components = {
    autocomplete: null,
};

(() => {
    if (typeof (window) !== 'undefined') {
        /* eslint-disable global-require */
        const { Loader } = require('google-maps');

        const loader = new Loader('AIzaSyCMV9_6WAgiVhAPiikv-SGoHb0_Vzo2BFk', {
            language: 'en',
            libraries: ['geometry', 'places'],
        });

        loader.load().then((google) => {
            components.autocomplete = new google.maps.places.AutocompleteService();
        });
    }
})();

export default components;